import getDirectStepAttributes from './getDirectStepAttributes';

const getTransformAttributes = ({ actionId, appId, stepId, apps, steps }) => {
  const step = steps?.find((n) => n?.id === stepId);
  const referenceStepId = step?.arguments?.stepId;
  const referenceStep = steps?.find((n) => n?.id === referenceStepId);

  const finalStepId = referenceStep?.id || stepId;
  const finalAppId = referenceStep?.appId || step?.appId || appId;

  return getDirectStepAttributes({ actionId, stepId: finalStepId, appId: finalAppId, steps, apps });
};

export default getTransformAttributes;
